import { FC, Fragment } from 'react';
import colors from 'tailwindcss/colors';

import { Icons, IconsTypes } from '@/components/shared/Icons';
import { Link } from '@/components/shared/Link';
import { formatLink, formatPathname } from '@/helpers/routing';
import { useSidebarMenu } from '@/hooks/useSidebarMenu';
import { ISiteMenuDropdown, SiteMenuItem } from '@/types';

interface ISidebarMenu {
  siteMenu: SiteMenuItem[];
}

export const SidebarMenu: FC<ISidebarMenu> = ({ siteMenu }) => {
  const { currentPageSlug, menuItem, showMenu, handleToggleMenu } = useSidebarMenu(siteMenu);
  const isCurrentSelected = (item: ISiteMenuDropdown) => [item?.page_slug, item?.blog_slug].includes(currentPageSlug);

  if (!menuItem) {
    return null;
  }
  const selectedPageName = menuItem.dropdown.find(isCurrentSelected);
  return (
    <div className="w-[278px]">
      <div className="relative -top-10 z-30 w-[273px] rounded-lg bg-white px-6 py-7 shadow-lg lg:items-start lg:px-5 lg:pb-2 xl:-left-1/3">
        <div className="flex w-full items-center justify-between lg:hidden" onClick={handleToggleMenu}>
          <div className="lg:hidden">{selectedPageName?.name ?? menuItem.name}</div>
          <div className="ml-5">{Icons({ name: IconsTypes.ARROW_DOWN, iconProps: { color: colors.black } })}</div>
        </div>

        <ul className={`h-full pt-2 lg:block lg:pt-0 ${showMenu ? 'block' : 'hidden'}`}>
          {menuItem.dropdown.map((item) => (
            <Fragment key={item.name}>
              <li>
                <Link
                  href={formatLink({ page_slug: item.page_slug, blog_slug: item.blog_slug })}
                  onClick={handleToggleMenu}
                  className={`block py-3 md:px-2 ${
                    isCurrentSelected(item) ? 'text-green hover:text-green-100' : 'text-black hover:text-black-400'
                  }`}
                >
                  {item.name}
                </Link>
              </li>

              <hr className="last:hidden" />
            </Fragment>
          ))}
        </ul>
      </div>
    </div>
  );
};
